/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
export const getStickyToolVerbs = stores => stores.stickyToolsStore.stickyToolVerbs;
export const getStickyToolVerbsDetails = stores => stores.stickyToolsStore.stickyToolVerbsDetails;
export const getIsStickyToolPanelVisible = stores => stores.stickyToolsStore.isStickyToolPanelVisible;
export const getStickyToolsAddOnPanel = stores => stores.stickyToolsStore.stickyToolsAddOnPanel;
